import { CurrentUser } from './currentUser.model';

export class Profile {
    name:string;
    storageType:string;
    code:string;
    firstName:string;
    familyName:string;

    /**
     *
     */
    constructor(currentUser:CurrentUser) {

        this.code = currentUser.code;
        this.firstName = currentUser.firstName;
        this.familyName = currentUser.familyName;
        this.name = currentUser.name;
        this.storageType = currentUser.storageType;
    }
}
